// extracted by mini-css-extract-plugin
export var disabled = "_p-a";
export var hierarchyLinkGray = "_p-4";
export var hierarchyLinkUnderline = "_p-3";
export var hierarchyPrimary = "_p-0";
export var hierarchySecondary = "_p-1";
export var hierarchyTertiary = "_p-2";
export var pressed = "_p-6";
export var themeAction = "_p-5";
export var themeDestructive = "_p-8";
export var themeNormal = "_p-7";
export var themeSuccess = "_p-9";